<h1 mat-dialog-title style="align-items: center; display: flex;">
  <mat-icon class="{{data?.iconClass}}">{{data?.icon}}</mat-icon>
  <span>{{data?.title}}</span>
</h1>
<div mat-dialog-content>
  @if(data?.html){
    <h5 class="title">{{data?.message}}</h5>
    <div [innerHTML]="data.html">
    </div>
  }
  @else {
  <span>{{data?.message}}</span>
}
</div>
<div mat-dialog-actions>
  @if (data?.cancelButtonText && data?.cancelButtonText != '') {
    <button mat-button class="tis-text-upper {{data?.cancelButtonClass ?? 'tis-btn-primary'}}" (click)="onClose(false)">{{data?.cancelButtonText}}</button>
  }
  @if (data?.approveButtonText && data?.approveButtonText != '') {
    <button mat-button class="tis-text-upper {{data?.approveButtonClass ?? 'tis-btn-primary'}}" (click)="onClose(true)" cdkFocusInitial>{{data?.approveButtonText}}</button>
  }
</div>
